import React from "react"
import Image from "next/image"
import MissingImage from "@/public/images/image-missing.png"

const LandingFiller = () => {
  return (
    <div className="cart-landing">
      <div className="container kf-react-container cart-landing">
        <div className="row no-gutters row-space-between">
          <div className="col-lg-9 cart-item-list-section ml-full-width">
            <div className="cart-landing__content">
              <div className="row no-gutters cart-items">
                <div className="col">
                  <div className="row no-gutters">
                    <div className="col-lg-12 col-sm-6 col-md-6 cart-header">
                      <div
                        className="cart-items__title"
                        role="heading"
                        aria-level="1"
                        aria-label="Your Cart 0 items"
                        data-testid="cartItem-title"
                      >
                        {`Your Cart`}
                      </div>
                      {/* <div className="cart-items__header-info">
                        <div className="cart-id-share">
                          <div className="download-specs d-none d-lg-block">
                            <div className="download-specs__cta">
                              <span
                                role="button"
                                tabindex="0"
                                name="socialShareModelClose"
                              >
                                Share Cart
                              </span>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <p className="mobile-share-cart-id">
                        Cart ID:{" "}
                        <div
                          className="shimmer"
                          style={{ width: 200, height: "auto" }}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="row cart-items__th no-gutters cart-table-header">
                    <div className="col-12 col-sm-6 col-md-6 d-sm-block">
                      <div
                        className="col-4 d-none d-sm-block text-left cart-items__td px-0"
                        aria-hidden="true"
                      >
                        Item
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 align-self-end">
                      <div className="row mx-0 px-0 cart-items__td-container">
                        <div
                          className="col-5 d-none d-sm-block cart-items__td cart-td-unit-price"
                          aria-hidden="true"
                        >
                          Item Price
                        </div>
                        <div
                          className="col-3 d-none d-sm-block text-center cart-items__td px-0"
                          aria-hidden="true"
                        >
                          Quantity
                        </div>
                        <div
                          className="col-4 d-none d-sm-block text-right cart-items__td px-0"
                          aria-hidden="true"
                        >
                          Total
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row cart-item no-gutters">
                    <div className="col-12 col-sm-6 mobile-full-width col-md-6 print-left">
                      <div className="cart-item__summary">
                        <a
                          role="button"
                          className="gbh-data-layer"
                          tabindex="0"
                          href="/cart#"
                        >
                          <span className="img-wrapper">
                            <Image
                              className="cart-item__image"
                              src={MissingImage.src}
                              width={120}
                              height={160}
                            />
                          </span>
                        </a>
                        <section className="cart-item__specs">
                          <div
                            className="cart-item__brand shimmer"
                            style={{ width: 100, height: 15 }}
                          ></div>
                          <a
                            role="button"
                            className="gbh-data-layer"
                            tabindex="0"
                            href="#"
                          >
                            <div
                              className="cart-item__name shimmer-loading__title shimmer"
                              style={{ marginTop: 20, marginBottom: 20 }}
                            ></div>
                          </a>
                          <p
                            className="cart-item__desc shimmer"
                            style={{ marginBottom: 8, height: 15 }}
                          ></p>
                          <p
                            className="cart-item__desc shimmer"
                            style={{ marginBottom: 8, height: 15 }}
                          ></p>
                          <p
                            className="cart-item__desc shimmer"
                            style={{ marginBottom: 8, width: 100, height: 15 }}
                          ></p>
                        </section>
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 cart-item__info print-right">
                      <div className="row cart-item__qty-price cart-qty-price-mobile mx-0 px-0">
                        <div className="cart-item__qty-mobile">&nbsp;</div>
                        <div className="col-5 cart-item__discount-container discount-container-padding">
                          <div className="cart-item__price">
                            <span
                              className="cart-item__total-price hide-mobile-price"
                              aria-description="Unit Price"
                            >
                              -
                            </span>
                            <div className="col-2 text-right cart-item__total px-0 mobile-total-price">
                              <span
                                className="cart-item__total-price"
                                aria-description="Total"
                              >
                                -
                              </span>
                            </div>
                            <br className="show-mobile" />
                          </div>
                        </div>
                        <div className="col-3 cart-item__qty px-0">-</div>
                        <div className="col-4 text-right cart-item__total px-0 hide-price-popup-mobile">
                          <span
                            className="cart-item__total-price hide-mobile-price"
                            aria-description="Total"
                          >
                            -
                          </span>
                        </div>
                        <div className="clear"></div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="cart-item__cta-wrapper hide-mobile-checkout-section">
                        <div className="remove-sec-cart">
                          <div className="cart-item__cta">
                            <span
                              tabindex="0"
                              role="button"
                              aria-label="Vive™ Remove"
                            >
                              Remove
                            </span>
                          </div>
                        </div>
                        <div className="clear"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ml-full-width order-summary-cart">
            <div className="row no-gutters order-summary-wrapper sticky-order">
              <div className="col-12 pl-0 pr-0">
                <div className="order-summary">
                  <div
                    className="order-summary__title"
                    role="heading"
                    aria-level="2"
                  >
                    Order Summary
                  </div>
                  <div className="order-summary__item">
                    <span className="order-summary__item--label">Subtotal</span>
                    <span className="order-summary__item--value">
                      <span>-</span>
                    </span>
                  </div>
                  <div className="order-summary__item">
                    <span className="order-summary__item--label">
                      Standard Shipping
                    </span>
                    <span className="order-summary__item--value">FREE</span>
                  </div>
                  <hr
                    role="presentation"
                    aria-hidden="true"
                    className="order-summary__separator cart_custom_margin_hr"
                  />
                  <div className="order-summary-mobile-sticky is-sticky-load">
                    <div className="order-summary__item estimated-total">
                      <span className="order-summary__item--label">
                        <span className="order-summary__item--label-wrapper">
                          <span className="order-summary__item--label-title">
                            Total
                          </span>
                        </span>
                      </span>
                      <span className="order-summary__item--value-large">
                        <span>-</span>
                      </span>
                    </div>
                    <div className="order-summary__item-hr">
                      <hr
                        role="presentation"
                        aria-hidden="true"
                        className="order-summary__separator cart_custom_margin_hr"
                      />
                    </div>
                    <div className="order-summary__item--tax-container pb-10">
                      <span className="order-summary__item--label tax-label">
                        {" "}
                        Tax
                      </span>
                      <span className="order-summary__item--label-description">
                        <span>Including</span>
                        <span className="order-summary__item--label-description--number-format">
                          <span>-</span>
                        </span>
                        <span> in taxes</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="Button_buttonWrapper__9Vvy_ kf-react-button button gbh-data-layer checkout-btn-group large primary flexible">
                  <a
                    className="kf-react-button button gbh-data-layer checkout-btn-group large primary flexible"
                    tabindex="0"
                    href="#"
                  >
                    Checkout
                  </a>
                </div>
                {/* <div className="cart-accordian">
                  <div className="Collapsible_Collapsible__OM2Mu">
                    <div className="header open">Promo Code</div>
                    <div className="body">
                      <div className="cart-accordion-section">
                        <div className="order-summary__input-group">
                          <div className="">
                            <div className="Input_inputFieldWrapper__vj2wJ">
                              <div
                                className="input-field order-summary__input"
                                id="promo-code-input-wrapper"
                              >
                                <div className="input-field__border">
                                  <div className="input-field__value">
                                    <input
                                      type="text"
                                      autocomplete="off"
                                      placeholder="Enter Promo Code"
                                    />
                                    <label
                                      for="promo-code-input"
                                      aria-hidden="true"
                                    >
                                      Enter Promo Code
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="Button_buttonWrapper__9Vvy_ kf-react-button button small ghost">
                            <button className="kf-react-button button small ghost">
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingFiller
